import { render, staticRenderFns } from "./rate-info.vue?vue&type=template&id=51b014cc&scoped=true"
import script from "./rate-info.vue?vue&type=script&lang=js"
export * from "./rate-info.vue?vue&type=script&lang=js"
import style0 from "./rate-info.vue?vue&type=style&index=0&id=51b014cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b014cc",
  null
  
)

export default component.exports